import React from 'react';
import { BodyText, Container, Sheet } from '@paypalcorp/pp-react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import _sortBy from 'lodash/sortBy';
import { getComplaintsData } from '../../../jsV2/helpers/twHelper';

const complaintsData = getComplaintsData();

function BrexitComplaintsDataSheet(props) {
  const { complaintDataSheetTitle, isComplaintDataSheetOpen, handleSheetClose } = props;

  // Complaint Data from RC
  const bankingAndCreditcard = _get(complaintsData, 'table.row.bankingAndCreditcard', {});
  const complaintsDataTableHeader = _get(complaintsData, 'table.header', {});
  const complaintsDataSheetHeader = _get(complaintsData, 'sheetHeader', {});

  const renderSheetInfoHeaderItems = () => {
    // sort function -> sortBy header item rank
    const sortHeaderItemByRank = ([, item]) => item.rank;
    // convert JSON object into map entries [[headerItemKey, headerItem], ...]
    const complaintsDataSheetHeaderItemsEntries = Object.entries(complaintsDataSheetHeader);
    // sort the header items by rank so we can control the sequence in the config
    const sortedComplaintsDataSheetHeaderItemsEntries = _sortBy(complaintsDataSheetHeaderItemsEntries, [
      sortHeaderItemByRank,
    ]);

    return sortedComplaintsDataSheetHeaderItemsEntries.map(([key, item]) => {
      return (
        <BodyText
          className="brexit_complaints_data__sheet__info__text"
          data-testid={`brexit-complaints-data-sheet-info-text-${key}`}
        >
          {item.key}
          <span
            className="brexit_complaints_data__sheet__info__content"
            data-testid={`brexit-complaints-data-sheet-info-content-${key}`}
          >
            {item.value}
          </span>
        </BodyText>
      );
    });
  };

  const renderComplaintsDataSheetInfo = () => {
    return (
      <Container className="brexit_complaints_data__sheet__info" data-testid="brexit-complaints-data-sheet-info">
        {renderSheetInfoHeaderItems()}
      </Container>
    );
  };

  const renderComplaintsDataSheetTable = () => {
    return (
      <table
        align="center"
        className="brexit_complaints_data__sheet__table"
        data-testid="brexit-complaints-data-sheet-table"
      >
        <thead className="brexit_complaints_data__sheet__table__header">
          <tr>
            <td />
            <th colSpan="2" className="brexit_complaints_data__sheet__table__top_header">
              {complaintsDataTableHeader.noComplaintsByBusiness}
            </th>
          </tr>
          <tr className="brexit_complaints_data__sheet__table__header_row">
            <th>{complaintsDataTableHeader.productService}</th>
            <th>{complaintsDataTableHeader.provision}</th>
            <th>{complaintsDataTableHeader.intermediation}</th>
            <th>{complaintsDataTableHeader.noComplaintsOpened}</th>
            <th>{complaintsDataTableHeader.noComplaintsClosed}</th>
            <th>{complaintsDataTableHeader.percentClosedWithin3Days}</th>
            <th>{complaintsDataTableHeader.percentClosedWithin8Weeks}</th>
            <th>{complaintsDataTableHeader.percentUpheld}</th>
            <th>{complaintsDataTableHeader.mainCause}</th>
          </tr>
        </thead>

        <tbody className="brexit_complaints_data__sheet__table__body">
          <tr className="brexit_complaints_data__sheet__table__body_row">
            <th>{bankingAndCreditcard.rowHeader}</th>
            <td>{bankingAndCreditcard.provision}</td>
            <td>{bankingAndCreditcard.intermediation}</td>
            <td>{bankingAndCreditcard.noComplaintsOpened}</td>
            <td>{bankingAndCreditcard.noComplaintsClosed}</td>
            <td>{bankingAndCreditcard.percentClosedWithin3Days}</td>
            <td>{bankingAndCreditcard.percentClosedWithin8Weeks}</td>
            <td>{bankingAndCreditcard.percentUpheld}</td>
            <td>{bankingAndCreditcard.mainCause}</td>
          </tr>
        </tbody>
      </table>
    );
  };

  return (
    <Sheet
      data-testid="brexit-complaints-data-sheet"
      containerClassName="brexit_complaints_data__sheet_container"
      wrapperClassName="brexit_complaints_data__sheet_wrapper"
      className="brexit_complaints_data__sheet"
      title={complaintDataSheetTitle}
      isOpen={isComplaintDataSheetOpen}
      onCloseComplete={handleSheetClose}
      mobileFixedHeight="90"
      noPadding
      hideTitle
    >
      <Container className="brexit_complaints_data__sheet__content" data-testid="brexit-complaints-data-sheet-content">
        {renderComplaintsDataSheetInfo()}
        {renderComplaintsDataSheetTable()}
      </Container>
    </Sheet>
  );
}

BrexitComplaintsDataSheet.propTypes = {
  complaintDataSheetTitle: PropTypes.string.isRequired,
  isComplaintDataSheetOpen: PropTypes.bool.isRequired,
  handleSheetClose: PropTypes.func.isRequired,
};

export default BrexitComplaintsDataSheet;
